import React from "react";
import { PeekStack, PeekTypography } from "@piiqtechnologies/ui-components";
export const ReportTypeTitle = ({ reportType }) => {
    return (React.createElement(PeekStack, { direction: "column", gap: 0.5, textAlign: "left" },
        React.createElement(PeekTypography, { variant: "h2", fontWeight: "fontWeightMedium" }, reportType.title),
        React.createElement(PeekTypography, { variant: "h4", fontWeight: "fontWeightMedium", color: reportType.isPrimaryAction ? "secondary" : "info.main" }, reportType.subtitle)));
};
export default ReportTypeTitle;
